jQuery(document).ready(function ($) {
	$('.o-front-slider__slides').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		asNavFor: '.o-front-slider__nav ul',
		accessibility: true,
		autoplay: true,
	});
	$('.o-front-slider__nav ul').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		asNavFor: '.o-front-slider__slides',
		focusOnSelect: true,
		accessibility: true,
	});
});
